import React from "react";
import { Button } from "@mui/material";

export default function DefaultButton(props) {
  return (
    <Button
      type="submit"
      variant="contained"
      color="primary"
      style={{
        backgroundColor: props.bgColor,
        color: "#ffffff",
        marginBottom: 20,
      }}
      fullWidth
      className="form-input"
      size="large"
      onClick={(e) => props.changeHandler(e, props.buttonText)}
      data-action={props.action ? props.action : null}
    >
      {props.buttonText ? props.buttonText : "Unknown"}
    </Button>
  );
}
